/* ==========================================================================
   Bundle deal — assets/bundle-deal.js

   Sepet matematigi kesindir: temaya HER ZAMAN 1 adet ekletilir, kalan her sey
   (paketin diger adetleri + hediyeler) once /cart/add.js ile eklenir. Boylece
   temanin quantity alanini nasil okudugu onemli olmaz.
   ========================================================================== */

(function () {
  'use strict';

  if (window.customElements && customElements.get('bundle-deal')) return;

  /* ---------------------------------------------------------------- money */
  /* Bicim, Liquid'in {{ 123456 | money }} ciktisindan turetilir; aktif market
     hangi para birimi/formati kullaniyorsa JS de onu kullanir. */
  function makeMoney(sample) {
    sample = String(sample || '');
    var m = sample.match(/[\d.,\s ']+/);
    if (!m) {
      return function (c) {
        return (c / 100).toFixed(2);
      };
    }
    var num = m[0];
    var pre = sample.slice(0, m.index) + (num.match(/^[\s ]*/)[0] || '');
    var suf = (num.match(/[\s ]*$/)[0] || '') + sample.slice(m.index + num.length);
    var core = num.replace(/^[\s ]+|[\s ]+$/g, '');
    var digits = core.replace(/\D/g, '');
    var dec = digits.length >= 6 ? 2 : 0;
    var seps = core.replace(/\d/g, '');
    var decSep = dec ? seps.charAt(seps.length - 1) : '';
    var thoSep = seps.length > (dec ? 1 : 0) ? seps.charAt(0) : '';

    return function (cents) {
      var neg = cents < 0;
      cents = Math.abs(Math.round(cents));
      var s = dec ? (cents / 100).toFixed(2) : String(Math.round(cents / 100));
      var parts = s.split('.');
      var head = parts[0];
      if (thoSep) head = head.replace(/\B(?=(\d{3})+(?!\d))/g, thoSep);
      return (neg ? '-' : '') + pre + head + (dec ? decSep + parts[1] : '') + suf;
    };
  }

  function applyRounding(cents, mode) {
    if (mode === 'whole') return Math.round(cents / 100) * 100;
    if (mode === 'end99') return Math.max(0, Math.round(cents / 100) * 100 - 1);
    if (mode === 'end95') return Math.max(0, Math.round(cents / 100) * 100 - 5);
    return cents;
  }

  /* ------------------------------------------------------------- registry */

  /* Tema DOM'u tamamen yeniden olusturursa element yok olur; secim ve
     kullanicinin degistirdigi satirlar bu haritada yasar. */
  var STATE = {};
  var REG = [];
  var wired = false;

  function stateFor(id) {
    if (!STATE[id]) STATE[id] = { sel: null, touched: {} };
    return STATE[id];
  }

  function connected() {
    return REG.filter(function (el) {
      return el.isConnected;
    });
  }

  /* Horizon'da quantity/id inputlari formun DISINDA olup form="..." attribute'u
     ile bagli olabiliyor; form.elements bunlari da kapsar. */
  function fieldOf(f, name) {
    var el = f.elements ? f.elements[name] : null;
    if (!el) return f.querySelector('[name="' + name + '"]');
    if (el.nodeType === 1) return el;
    if (el.length) return el[0];
    return null;
  }

  function widgetForForm(f) {
    var list = connected();
    if (!list.length) return null;
    var i;
    var inp = fieldOf(f, 'id');

    if (inp) {
      for (i = 0; i < list.length; i++) if (list[i].hasVariant(inp.value)) return list[i];
      return null;
    }
    var scope = f.closest('product-info, .shopify-section, .main-product-information');
    if (scope) {
      for (i = 0; i < list.length; i++) if (scope.contains(list[i])) return list[i];
    }
    return null;
  }

  function intercept(e) {
    var f = null;
    var btn = null;

    if (e.type === 'submit') {
      f = e.target;
    } else {
      var t = e.target;
      if (!t || !t.closest) return;
      btn = t.closest(
        '[name="add"], button[type="submit"], input[type="submit"], .add-to-cart, [data-add-to-cart]'
      );
      if (!btn) return;
      if (btn.closest('.shopify-payment-button')) return;
      f = btn.closest('form[action*="/cart/add"]');
    }

    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    if (f.__bdPass && Date.now() < f.__bdPass) return;

    var w = widgetForForm(f);
    if (!w || !w.isReady()) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    w.addToCart(f, btn);
  }

  function wire() {
    if (wired) return;
    wired = true;
    document.addEventListener('click', intercept, true);
    document.addEventListener('submit', intercept, true);
  }

  /* --------------------------------------------------------------- element */

  class BundleDeal extends HTMLElement {}

  var proto = BundleDeal.prototype;

  proto.connectedCallback = function () {
    if (REG.indexOf(this) === -1) REG.push(this);
    wire();
    this.boot();
    this.observe();
  };

  proto.disconnectedCallback = function () {
    var i = REG.indexOf(this);
    if (i > -1) REG.splice(i, 1);
    if (this._mo) {
      this._mo.disconnect();
      this._mo = null;
    }
  };

  proto.state = function () {
    return stateFor(this.id || 'bundle-deal');
  };

  /* --- veri --- */

  proto.boot = function () {
    var node = this.querySelector('script[data-bd-data]');
    if (!node) return;

    if (!this._data) {
      try {
        this._data = JSON.parse(node.textContent);
      } catch (err) {
        this._data = null;
      }
      if (!this._data || !this._data.variants || !this._data.variants.length) {
        this._data = null;
        return;
      }
      this._money = makeMoney(this._data.money);
      this._vmap = {};
      for (var i = 0; i < this._data.variants.length; i++) {
        this._vmap[this._data.variants[i].id] = this._data.variants[i];
      }
    }

    var bars = this.bars();
    if (!bars.length) return;

    var st = this.state();
    if (typeof st.sel !== 'number' || st.sel >= bars.length) {
      st.sel = 0;
      for (var b = 0; b < bars.length; b++) {
        if (bars[b].getAttribute('data-default') === '1') st.sel = b;
      }
    }

    this.restore();
    this.hideThemeQuantity();
    this.paint();
    this.bind();
  };

  proto.bind = function () {
    if (this._bound) return;
    this._bound = true;
    var self = this;

    this.addEventListener('click', function (e) {
      var bar = e.target.closest('[data-bd-bar]');
      if (!bar) return;
      var idx = self.bars().indexOf(bar);
      var swatch = e.target.closest('[data-bd-val]');

      /* Renk/varyant secimi: satiri "dokunulmus" isaretle, fiyati yeniden ciz,
         sonra temanin varyant secicisini de ayni varyanta getir -> ana gorsel
         galerisi o renge atlar. */
      if (swatch) {
        e.preventDefault();
        self.setSwatch(swatch);
        var row = swatch.closest('[data-bd-item]');
        if (row && idx > -1) {
          var vals = self.valuesOf(row);
          self.state().touched[idx + ':' + row.getAttribute('data-bd-item')] = vals;
          self.state().sel = idx;
          self.paint();
          self.syncTheme(self.matchVariant(vals));
        }
        return;
      }

      if (idx > -1 && idx !== self.state().sel) {
        self.state().sel = idx;
        self.paint();
      }
    });

    this.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (e.target.closest('[data-bd-val]')) return;
      var bar = e.target.closest('[data-bd-bar]');
      if (!bar) return;
      e.preventDefault();
      var idx = self.bars().indexOf(bar);
      if (idx > -1) {
        self.state().sel = idx;
        self.paint();
      }
    });
  };

  proto.setSwatch = function (swatch) {
    var group = swatch.closest('[data-bd-opt]');
    if (!group) return;
    var btns = group.querySelectorAll('[data-bd-val]');
    for (var i = 0; i < btns.length; i++) {
      var on = btns[i] === swatch;
      btns[i].classList.toggle('is-on', on);
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  };

  proto.isReady = function () {
    return !!(this._data && this.bars().length);
  };

  proto.hasVariant = function (id) {
    return !!(this._vmap && this._vmap[id]);
  };

  proto.bars = function () {
    return Array.prototype.slice.call(this.querySelectorAll('[data-bd-bar]'));
  };

  proto.valuesOf = function (row) {
    var groups = row.querySelectorAll('[data-bd-opt]');
    var vals = [];
    for (var g = 0; g < groups.length; g++) {
      var on = groups[g].querySelector('[data-bd-val].is-on');
      if (!on) on = groups[g].querySelector('[data-bd-val]');
      vals.push(on ? on.getAttribute('data-bd-val') : '');
    }
    return vals;
  };

  /* --- tema DOM'u yeniden ciziince state'i koru --- */

  proto.observe = function () {
    if (this._mo || !window.MutationObserver) return;
    var self = this;
    this._mo = new MutationObserver(function () {
      if (self._painting) return;
      cancelAnimationFrame(self._raf);
      self._raf = requestAnimationFrame(function () {
        self.boot();
      });
    });
    this._mo.observe(this, { childList: true, subtree: true });
  };

  /* Sadece kullanicinin elle degistirdigi satirlar geri yuklenir. Dokunulmamis
     satirlar sunucudan gelen (yani aktif tema varyanti) degeriyle kalir. */
  proto.restore = function () {
    var touched = this.state().touched;
    var bars = this.bars();
    for (var key in touched) {
      if (!Object.prototype.hasOwnProperty.call(touched, key)) continue;
      var parts = key.split(':');
      var bar = bars[parseInt(parts[0], 10)];
      if (!bar) continue;
      var row = bar.querySelector('[data-bd-item="' + parts[1] + '"]');
      if (!row) continue;
      var vals = touched[key];
      var groups = row.querySelectorAll('[data-bd-opt]');
      for (var g = 0; g < groups.length && g < vals.length; g++) {
        var btns = groups[g].querySelectorAll('[data-bd-val]');
        for (var b = 0; b < btns.length; b++) {
          if (btns[b].getAttribute('data-bd-val') === vals[g]) {
            if (!btns[b].classList.contains('is-on')) this.setSwatch(btns[b]);
            break;
          }
        }
      }
    }
  };

  /* --- varyantlar --- */

  proto.matchVariant = function (vals) {
    var vs = this._data.variants;
    outer: for (var k = 0; k < vs.length; k++) {
      for (var j = 0; j < vals.length; j++) {
        if (vs[k].o[j] !== vals[j]) continue outer;
      }
      return vs[k];
    }
    return null;
  };

  proto.themeVariant = function () {
    var f = this.themeForm();
    var inp = f && fieldOf(f, 'id');
    if (inp && this._vmap[inp.value]) return this._vmap[inp.value];

    try {
      var u = new URLSearchParams(location.search).get('variant');
      if (u && this._vmap[u]) return this._vmap[u];
    } catch (err) {
      /* noop */
    }

    var vs = this._data.variants;
    for (var k = 0; k < vs.length; k++) if (vs[k].a) return vs[k];
    return vs[0];
  };

  proto.themeForm = function () {
    var scope = this.closest('product-info') || this.closest('.shopify-section') || document;
    var fs = scope.querySelectorAll('form[action*="/cart/add"]');
    for (var k = 0; k < fs.length; k++) {
      var inp = fieldOf(fs[k], 'id');
      if (inp && this._vmap[inp.value]) return fs[k];
    }
    return fs[0] || null;
  };

  /* Temanin varyant secicisindeki kontrolleri, secenek sirasina gore gruplar. */
  proto.themeOptionGroups = function () {
    var scope = this.closest('product-info') || this.closest('.shopify-section');
    if (!scope) return [];
    var picker =
      scope.querySelector(
        'variant-picker, variant-selects, variant-radios, .variant-picker, [data-variant-picker]'
      ) || scope;

    var nodes = picker.querySelectorAll('input[type="radio"], select');
    var order = [];
    var byKey = {};
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest('bundle-deal')) continue;
      var key = el.tagName === 'SELECT' ? 's' + i : 'r' + el.name;
      if (!byKey[key]) {
        byKey[key] = [];
        order.push(byKey[key]);
      }
      byKey[key].push(el);
    }
    return order;
  };

  proto.syncTheme = function (variant) {
    if (!variant) return;
    var cur = this.themeVariant();
    if (cur && cur.id === variant.id) return;

    var groups = this.themeOptionGroups();
    if (!groups.length) return;

    var n = Math.min(groups.length, variant.o.length);
    for (var i = 0; i < n; i++) {
      var g = groups[i];
      var val = variant.o[i];
      if (g[0].tagName === 'SELECT') {
        if (g[0].value !== val) {
          g[0].value = val;
          g[0].dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        for (var k = 0; k < g.length; k++) {
          if (g[k].value === val) {
            if (!g[k].checked) g[k].click();
            break;
          }
        }
      }
    }
  };

  proto.itemsOf = function (idx) {
    var bar = this.bars()[idx];
    var qty = parseInt(bar.getAttribute('data-qty'), 10) || 1;
    var rows = bar.querySelectorAll('[data-bd-item]');
    var out = [];
    var k;

    if (!rows.length) {
      var cv = this.themeVariant();
      for (k = 0; k < qty; k++) out.push(cv);
      return out;
    }

    for (k = 0; k < rows.length; k++) {
      out.push(this.matchVariant(this.valuesOf(rows[k])) || this.themeVariant());
    }
    return out;
  };

  proto.totalsOf = function (idx) {
    var bar = this.bars()[idx];
    var mode = bar.getAttribute('data-mode');
    var pct = parseFloat(bar.getAttribute('data-percent')) || 0;
    var amt = parseInt(bar.getAttribute('data-amount'), 10) || 0;
    var items = this.itemsOf(idx);
    var sum = 0;
    var was = 0;

    for (var k = 0; k < items.length; k++) {
      var v = items[k];
      sum += v.p;
      was += v.c && v.c > v.p ? v.c : v.p;
    }

    /* Shopify otomatik indirimleri en UCUZ uygun urune uygulanir; ayni
       siralamayi kullaniyoruz ki gosterilen tutar kasadakiyle tutsun. */
    var prices = [];
    for (var n = 0; n < items.length; n++) prices.push(items[n].p);
    prices.sort(function (a, c) {
      return a - c;
    });

    var total = sum;
    var off = 0;

    if (mode === 'percent') {
      off = (sum * pct) / 100;
    } else if (mode === 'extra') {
      for (var e = 0; e < prices.length - 1; e++) off += (prices[e] * pct) / 100;
    } else if (mode === 'second') {
      if (prices.length > 1) off = (prices[0] * pct) / 100;
    }

    if (mode === 'amount') {
      total = Math.max(0, sum - amt);
    } else if (mode === 'fixed') {
      total = amt;
    } else {
      total = Math.round(sum - off);
    }

    total = applyRounding(total, bar.getAttribute('data-rounding'));
    return { total: total, was: was };
  };

  /* --- boyama --- */

  proto.paint = function () {
    if (!this._data) return;
    this._painting = true;

    var sel = this.state().sel;
    var bars = this.bars();

    for (var b = 0; b < bars.length; b++) {
      var bar = bars[b];
      var on = b === sel;
      bar.classList.toggle('is-selected', on);
      bar.setAttribute('aria-pressed', on ? 'true' : 'false');

      var t = this.totalsOf(b);
      var priceEl = bar.querySelector('[data-bd-price]');
      var wasEl = bar.querySelector('[data-bd-was]');
      if (priceEl) priceEl.textContent = this._money(t.total);
      if (wasEl) {
        if (t.was > t.total) {
          wasEl.textContent = this._money(t.was);
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      }

    }

    if (this.getAttribute('data-sync-btn') === '1') this.paintButton();

    var self = this;
    Promise.resolve().then(function () {
      if (self._mo) self._mo.takeRecords();
      self._painting = false;
    });
  };

  proto.paintButton = function () {
    var f = this.themeForm();
    if (!f) return;
    var btn = f.querySelector('[name="add"], button[type="submit"]');
    if (!btn || btn.tagName === 'INPUT') return;
    var span = btn.querySelector('.bundle-deal-btn-price');
    if (!span) {
      span = document.createElement('span');
      span.className = 'bundle-deal-btn-price';
      btn.appendChild(span);
    }
    span.textContent = ' • ' + this._money(this.totalsOf(this.state().sel).total);
  };

  proto.hideThemeQuantity = function () {
    if (this.getAttribute('data-hide-qty') !== '1') return;
    var scope = this.closest('product-info') || this.closest('.shopify-section');
    if (!scope) return;
    var nodes = scope.querySelectorAll(
      'quantity-selector-component, quantity-input, .quantity-selector, .product-form__quantity, .product-form__input--quantity, .quantity-input__container'
    );
    for (var k = 0; k < nodes.length; k++) nodes[k].style.display = 'none';
  };

  /* --- sepete ekleme --- */

  proto.plan = function () {
    var bar = this.bars()[this.state().sel];
    if (!bar) return null;

    var title = bar.getAttribute('data-title') || '';
    var items = this.itemsOf(this.state().sel);
    if (!items.length) return null;

    var groups = {};
    for (var k = 0; k < items.length; k++) {
      groups[items[k].id] = (groups[items[k].id] || 0) + 1;
    }

    var keys = Object.keys(groups).sort(function (a, c) {
      return groups[c] - groups[a];
    });

    var primary = parseInt(keys[0], 10);
    var extras = [];

    /* primary'nin 1 adedi temanin formuyla eklenecek, kalani burada.
       Hediyeler sepete EKLENMEZ — onlar sadece gorsel. */
    if (groups[keys[0]] > 1) {
      extras.push({ id: primary, quantity: groups[keys[0]] - 1 });
    }
    for (var j = 1; j < keys.length; j++) {
      extras.push({ id: parseInt(keys[j], 10), quantity: groups[keys[j]] });
    }

    return { primary: primary, extras: extras, title: title, units: items.length };
  };

  proto.cartAddUrl = function () {
    var root = (this._data && this._data.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'cart/add.js';
  };

  proto.addToCart = function (f, btn) {
    if (this._busy) return;
    var p = this.plan();
    if (!p) return;

    var self = this;
    this._busy = true;
    var release = function () {
      setTimeout(function () {
        self._busy = false;
      }, 1000);
    };

    if (!p.extras.length) {
      this.fire(f, btn, p);
      release();
      return;
    }

    if (btn) btn.classList.add('bundle-deal-busy');

    fetch(this.cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: p.extras })
    })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return null;
      })
      .then(function () {
        if (btn) btn.classList.remove('bundle-deal-busy');
        self.fire(f, btn, p);
        release();
      });
  };

  /* Temaya HER ZAMAN 1 adet ekletiyoruz — quantity'yi temanin nasil okudugu
     onemli olmasin diye. Geri kalan adetler zaten extras ile eklendi. */
  proto.fire = function (f, btn, p) {
    var idInput = fieldOf(f, 'id');
    var qtyInput = fieldOf(f, 'quantity');
    var prevQty = null;

    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      f.appendChild(qtyInput);
    } else {
      prevQty = qtyInput.value;
    }

    if (idInput) idInput.value = p.primary;
    qtyInput.value = 1;

    f.__bdPass = Date.now() + 4000;

    if (btn) btn.click();
    else if (f.requestSubmit) f.requestSubmit();
    else f.submit();

    setTimeout(function () {
      if (prevQty !== null && qtyInput.isConnected) qtyInput.value = prevQty;
    }, 2500);
  };

  customElements.define('bundle-deal', BundleDeal);
})();